import {YearsAction} from "../actions/Years";

const Years = (state: number[] = [], action: YearsAction) => {
    switch (action.type) {
        case "INIT_YEARS":
            return action.initialState;
        default:
            return state;
    }
};

export default Years